import {
  QueueDashboardInfo,
  QueueDashboardSessionResponse,
  QueueDashboardSessionResult,
  Result
} from '../types';
import { ApiClient } from './apiClient';

export class QueueDashboardService {
  constructor(private apiClient: ApiClient) {}

  getInfo(): Promise<Result<QueueDashboardInfo>> {
    return this.apiClient.get<QueueDashboardInfo>('/api/queue-dashboard/info', undefined, {
      skipErrorNotification: true
    });
  }

  async createSession(token: string): Promise<QueueDashboardSessionResult> {
    const baseUrl = process.env.REACT_APP_CHAT_APP_URL || '';

    if (!baseUrl) {
      return { data: null, error: 'API base URL is not configured.', success: false };
    }

    try {
      const response = await fetch(`${baseUrl}/api/queue-dashboard/session`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`
        },
        credentials: 'include'
      });

      if (!response.ok) {
        const errorPayload = await response.json().catch(() => null);
        const message =
          (errorPayload && typeof errorPayload === 'object' && 'message' in errorPayload
            ? String(errorPayload.message)
            : null) ||
          (response.status === 403
            ? 'Only administrators can open the queue dashboard.'
            : response.status === 401
              ? 'Session expired. Please log in again.'
              : 'Failed to start queue dashboard session.');

        return { data: null, error: message, success: false, status: response.status };
      }

      const data = (await response.json()) as QueueDashboardSessionResponse;
      return { data, error: null, success: true };
    } catch (error) {
      const isNetworkError =
        error instanceof TypeError &&
        (error.message === 'Failed to fetch' || error.message.includes('NetworkError'));

      const message = isNetworkError
        ? 'Could not reach the queue dashboard API. Check CORS_ORIGIN and that the API is running.'
        : error instanceof Error
          ? error.message
          : 'Failed to start queue dashboard session.';
      return { data: null, error: message, success: false };
    }
  }

  getDashboardFullUrl(dashboardUrl: string): string {
    const baseUrl = process.env.REACT_APP_CHAT_APP_URL || '';
    return `${baseUrl}${dashboardUrl}`;
  }
}
